<div class="relative flex flex-col gap-1.5">
  <div tabindex="0" cdkOverlayOrigin #trigger="cdkOverlayOrigin" (click)="toggleDropdown()">
    <ng-content select="[libDropdownTrigger]"></ng-content>
  </div>
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayPositions]="overlayPositionStrategy"
    [cdkConnectedOverlayMinWidth]="trigger.elementRef.nativeElement.clientWidth"
    [cdkConnectedOverlayPush]="true"
    [cdkConnectedOverlayOpen]="dropdownOpen()"
    [cdkConnectedOverlayHasBackdrop]="true"
    (backdropClick)="toggleDropdown()"
    [cdkConnectedOverlayBackdropClass]="['opacity-0']"
  >
    <div
      [style.minWidth]="trigger.elementRef.nativeElement.clientWidth + 'px'"
      [style.maxHeight]="'300px'"
      class="z-[1] flex select-none flex-col justify-between gap-4 overflow-x-auto rounded-[28px] border-2 border-states-white bg-background-white bg-opacity-[0.56] p-4 shadow-card backdrop-blur-[10px]"
    >
      <form [formGroup]="formGroup" class="flex items-center gap-2">
        <lib-switch formControlName="isCompactView"></lib-switch>
        <span class="typo-h4-light">{{ 'schedule_calendar_compact_view' | translate }}</span>
      </form>

      <!-- TODO: Temporary client requirement to display tentative filter only in showcase -->
      @if (isShowcase) {
        <form [formGroup]="formGroup" class="flex items-center justify-between gap-2">
          <lib-switch formControlName="showTentative"></lib-switch>
          <span class="typo-h4-light">{{ 'schedule_calendar_show_tentative' | translate }}</span>
        </form>
      }

      <hr class="w-full border-background-disabled" />

      <button class="flex h-[30px] items-center justify-start" (click)="toggleSelectAll()">
        <div class="flex items-center gap-2">
          <lib-checkbox [checked]="isAllSelected()"></lib-checkbox>

          <span [class]="'typo-h4-light min-w-max text-text-primary'">{{ 'schedule_calendar_show_all_operatories' | translate }}</span>
        </div>
      </button>

      @for (item of dropdownItems(); track item.value) {
        <button class="flex h-[30px] items-center justify-start" (click)="onItemClick(item)">
          <div class="flex items-center gap-2">
            <lib-checkbox [checked]="isItemSelected(item)"></lib-checkbox>
            @if (item.imageUrl) {
              <img class="h-[32px] w-[32px] rounded-full" [src]="item.imageUrl" />
            }
            <span [class]="'typo-h4-light min-w-max text-text-primary' + item.itemOverviewClass">{{ item.label }}</span>
          </div>
        </button>
      }
    </div>
  </ng-template>
</div>
